import { BundleStatusEnum } from '#types';
import Globals from '../../Globals';
import { getCookie } from '../getCookie';
import { BundleCookie } from './bundleCookieType';
import { setDocumentOptionCookie } from './setDocumentOptionCookie';

/**
 * Updates a bundle object based on users cookies, the contactID passed, and the action taken.
 */
export const updateBundleCookieAfterSending = ( {
	contactID,
	contractSent,
	invoiceSent,
	proposalSent,
	eventDate,
	dueDate,
	title,
}: Omit<
BundleCookie,
'proposalBundleStatus' | 'contractBundleStatus' | 'invoiceBundleStatus'
> & {
	contractSent?: true;
	invoiceSent?: true;
	proposalSent?: true;
} ) => {
	// were we expecting a bundle
	const documentCookie = getCookie(
		`${ Globals.DocumentBundle }=`,
		document.cookie
	);
	if ( documentCookie ) {
		const cookieData: BundleCookie = JSON.parse( documentCookie );
		if ( contactID ) {
			const {
				bundle,
				proposalBundleStatus,
				contractBundleStatus,
				invoiceBundleStatus,
				...rest
			} = cookieData;
			const newBundleCookie: BundleCookie = {
				...rest, // carry-over the rest of the cookie data
				contactID,
				bundle,
				contractBundleStatus: contractSent
					? BundleStatusEnum.Sent
					: contractBundleStatus,
				invoiceBundleStatus: invoiceSent
					? BundleStatusEnum.Sent
					: invoiceBundleStatus,
				proposalBundleStatus: proposalSent
					? BundleStatusEnum.Sent
					: proposalBundleStatus,
				// update dueDate, and title
				...( !rest.dueDate && !!dueDate ? { dueDate } : {} ),
				/* Title, like eventDate, is a "running value", and title must be url-encoded to escape
				ampersands and other special characters */
				...( title ? { title: encodeURIComponent( title ) } : {} ),
				/* eventDate can be null, in the case of using a contact with an event date on proposal
				create pages, clearing it, then landing on contract create, for example */
				...( eventDate !== 'undefined' ? { eventDate } : {} ),
			};
			setDocumentOptionCookie( newBundleCookie );
			return newBundleCookie;
		} else {
			/* We can only have one bundle cookie at a time, and sending a document on a
			different contact invalidates the bundle cookie */
			setDocumentOptionCookie();
		}
	}
};
